import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";
import "../styles/QuestionBankStyles.css";

interface RightAnswerSelectProps {
  value: string;
  onChange: (val: string) => void;
  disabled?: boolean;
}

const OPTIONS = [
  { value: "A", label: "Option A" },
  { value: "B", label: "Option B" },
  { value: "C", label: "Option C" },
  { value: "D", label: "Option D" },
];

const RightAnswerSelect: React.FC<RightAnswerSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (val: string) => {
    onChange(val);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="qb-right-answer-wrapper">
      <button
        type="button"
        className={`qb-right-answer-trigger ${isOpen ? "open" : ""} ${disabled ? "disabled" : ""}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="qb-right-answer-label">Right Answer:</span>
        <span className="qb-right-answer-val">{value || "A"}</span>
        <ChevronDown
          size={14}
          className={`qb-right-answer-chevron ${isOpen ? "rotated" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="qb-right-answer-dropdown">
          {OPTIONS.map((opt) => {
            const isSelected = opt.value === value;
            return (
              <div
                key={opt.value}
                className={`qb-right-answer-item ${isSelected ? "selected" : ""}`}
                onClick={() => handleSelect(opt.value)}
              >
                <div className="qb-right-answer-item-left">
                  <span className={`qb-right-answer-badge ${isSelected ? "selected" : ""}`}>
                    {opt.value}
                  </span>
                  <span>{opt.label}</span>
                </div>
                {isSelected && <Check size={14} className="qb-right-answer-check" />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RightAnswerSelect;
